export default __webpack_public_path__ + "static/media/react.60b5dd47.png";